import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { formatCurrency } from '../../../../../utils/FormatCurrency';

export const ActiveDirectDebits = ({ orders }) => {
  const allItems = orders.flatMap((order) => order.items || []);
  const recentItems = allItems.slice(0, 2);
  const hasActiveDebits = recentItems.length > 0;

  return (
    <div className="mb-4 lg:w-1/2">
      <div className="flex justify-between items-baseline">
        <h1 className="font-semibold text-2xl mb-4">Active Direct Debits</h1>
        {hasActiveDebits && (
          <Link
            to="/user-dashboard/shopping-overview/purchases"
            className="underline font-medium text-[#737376] text-sm"
          >
            See all
          </Link>
        )}
      </div>

      <section className="grid grid-cols-1 gap-4 border w-full rounded-[10px]">
        {!hasActiveDebits ? (
          <p className="text-[#A6A6A6] bg-[#F6F6F6] p-4 py-6 rounded-[10px]">
            No active direct debits
          </p>
        ) : (
          recentItems.map((item, index) => (
            <div key={index}>
              <ul className="recently-viewed p-">
                <SingleActiveDirectDebitItem item={item} />
              </ul>
              {index === 0 && recentItems.length > 1 && (
                <hr className="border-t border-gray-200 mx-2 " />
              )}
            </div>
          ))
        )}
      </section>
    </div>
  );
};

const SingleActiveDirectDebitItem = ({ item }) => {
  return (
    <li className="recentlyviewed-item grid grid-cols-1 gap-3">
      <Link to={`/user-dashboard/shopping-overview/direct-debits`}>
        <div className="flex items-center p-2 justify-between text-balance">
          <div className="flex items-center space-x-3">
            <div className="h-[60px] w-[60px] border rounded-xl flex justify-center items-center">
              <img
                src={item?.coverImage || '/placeholder-image.jpg'}
                className="h-[44px] w-[44px] rounded-lg object-cover"
                alt={item?.productName || 'Product image'}
              />
            </div>

            <div>
              <p className="mb-1 md:mb-3 font-medium">
                {item.productName?.length > 30
                  ? item.productName.slice(0, 30) + '...'
                  : item?.productName || 'Unnamed Product'}
              </p>
            </div>
          </div>

          <div className="flex flex-col items-end">
            <Link
              to={`/user-dashboard/shopping-overview/purchases`}
              className="mb-6 lg:mb-3"
            >
              <ChevronRight className="cursor-pointer" size={24} />
            </Link>
          </div>
        </div>
      </Link>
    </li>
  );
};
